export const version = "bignumber/5.6.0";
